import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { IEvent } from '@/enitites/event/model/types'
import IconLike from '@/shared/icons/IconLike.vue'
import IconMinusCircle from '@/shared/icons/IconMinusCircle.vue'
import IconPlusCircle from '@/shared/icons/IconPlusCircle.vue'
import { EVENT_STAR_CONFIG } from '../constants'

interface Props {
  event?: IEvent
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EventFeedbackBlockAdmin',
  props: {
    event: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { event: IEvent };



const isOpenRating = ref(false)

const RATING_CATEGORIES = [
  { key: 'timeliness', label: 'Timeliness', value: props.event?.score.timeliness },
  { key: 'communication', label: 'Communication', value: props.event?.score.communication },
  { key: 'venue', label: 'Venue', value: props.event?.score.venue },
  { key: 'vibe', label: 'Vibe', value: props.event?.score.vibe },
  { key: 'musicSound', label: 'Music / Sound', value: props.event?.score.musicSound },
] as const

const displayReviewCount = computed(() => `${props.event?.score.countFeedbacks} reviews`)

const handleClickTopButton = () => {
  isOpenRating.value = !isOpenRating.value
}

const displayOverallRating = computed(() => `${props.event?.score.averageRating}/5`)

return { __sfc: true,props, isOpenRating, RATING_CATEGORIES, displayReviewCount, handleClickTopButton, displayOverallRating, IconLike, IconMinusCircle, IconPlusCircle, EVENT_STAR_CONFIG }
}

})